import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface ReviewAnnualMinimumModalJurisdictionData {
  jurisdictionName: string;
  minAnnualAmount: number;
  estimatedAnnualTotal: number;
}

@Component({
  selector: 'app-variable-benefit-configuration-review-annual-minimum-modal',
  templateUrl: './variable-benefit-configuration-review-annual-minimum-modal.component.html',
  styleUrls: ['./variable-benefit-configuration-review-annual-minimum-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitConfigurationReviewAnnualMinimumModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  public jurisdictions: ReviewAnnualMinimumModalJurisdictionData[] = [];

  public setJurisdictions(jurisdictions: ReviewAnnualMinimumModalJurisdictionData[]): void {
    this.jurisdictions = jurisdictions;
  }

  public editValues(): void {
    this.ngbActiveModal.dismiss();
  }

  public continueWithSpecifiedValues(): void {
    this.ngbActiveModal.close(true);
  }
}
